// DefaultValueField.jsx

import React from 'react';

// Utilities
import { CURRENCY_CODE_OPTIONS, DEFAULT_CURRENCY_CODE } from 'utilities/Currency';

// CSS
import './DefaultValueField.css';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import SelectInput from 'components/selectinput/SelectInput';
import TextInput from 'components/textinput/TextInput';

/**
 * DefaultValueField
 *
 * @returns {ReactNode} The rendered component.
 */
const DefaultValueField = ({
    draft,
    isEnumType,
    isTagsType,
    selectedEnumOptions,
    theme,
    onDefaultChange,
}) => {

  // ----- RENDER ----- //

  return (
    <div className="field-modal-field">

        {/* LABEL */}
        <div
          className="field-modal-label"
        >
            Default Value
        </div>

        {/* CHECKBOX */}
        {isTagsType ? (
            <div className="field-modal-empty">Defaults are not supported for tags.</div>
        ) : draft.type === 'boolean' ? (
            <div className="field-modal-checkbox">
                <Checkbox
                  value={!!draft.default}
                  size="22"
                  label={draft.default ? 'True' : 'False'}
                  onChange={() => onDefaultChange(!draft.default)}
                />
            </div>
        ) : isEnumType ? (
            <SelectInput
              style={{
                width: '220px',
              }}
              value={draft.default ?? ''}
              disabled={selectedEnumOptions.length === 0}
              options={[
                { value: '', label: 'No default' },
                ...selectedEnumOptions.map((option) => ({
                  value: option.value,
                  label: option.value,
                })),
              ]}
              onChange={(e) => onDefaultChange(e.target.value === '' ? undefined : e.target.value)}
            />
        ) : draft.type === 'currency' ? (
            <SelectInput
              style={{
                width: '220px',
              }}
              value={draft.default || DEFAULT_CURRENCY_CODE}
              options={CURRENCY_CODE_OPTIONS}
              onChange={(e) => onDefaultChange(e.target.value)}
            />
        ) : (
            <TextInput
              placeholder={
                    draft.type === 'number'
                        ? 'e.g. 0'
                        : draft.type === 'percentage'
                            ? '0-100'
                            : draft.type === 'money'
                                ? 'e.g. 0.00'
                            : draft.type === 'phone'
                                ? '(415) 555-1212'
                            : draft.type === 'email'
                                ? 'name@example.com'
                            : ''
                }
              value={
                    draft.default === undefined || draft.default === null
                        ? ''
                        : String(draft.default)
                }
              onChange={(e) => onDefaultChange(e.target.value)}
            />
        )}
    </div>
);
};

// Dev Tools
DefaultValueField.displayName = 'DefaultValueField';

export default DefaultValueField;
